import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  IRealEstate,
  IRealEstateLandParcel,
  IRealEstateParcel,
} from '../../../../Interfaces/IRealEstate';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';

import { ILegalTransactionRelationshipRealEstate } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipRealEstate/ILegalTransactionRelationshipRealEstate';
import { ICourt } from '../../../../Interfaces/ICourt';

interface IProps {
  currentObject: IRealEstate;
  setCurrentObject: React.Dispatch<React.SetStateAction<IRealEstate>>;
  marginTop?: number;
}

export type DialogType = 'parcel' | 'landparcel' | '';

export const emptyParcel = (
  currentObject: IRealEstate | ILegalTransactionRelationshipRealEstate
): IRealEstateParcel => {
  return {
    idRealEstateParcel: -1,
    Parcel: '',
    RealEstate_idRealEstate: currentObject.idRealEstate,
  };
};

export const emptyLandParcel = (
  currentObject: IRealEstate | ILegalTransactionRelationshipRealEstate
): IRealEstateLandParcel => {
  return {
    idRealEstateLandParcel: -1,
    LandParcel: '',
    RealEstate_idRealEstate: currentObject.idRealEstate,
  };
};

export const MortgageRealEstateLandRegister: React.FC<IProps> = ({
  currentObject,
  setCurrentObject,
  marginTop,
}) => {
  useEffect(() => {
    console.log(currentObject);
  }, [currentObject]);
  const [expanded, setExpanded] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState<DialogType>('');

  const setCourt = (CourtObject: ICourt | null | undefined) => {
    setCurrentObject({
      ...currentObject,
      idCourt: CourtObject?.idCourt,
      Court: CourtObject,
    } as IRealEstate);
  };

  /*const onDialogSave = (newValue: string, dialogType: DialogType) => {
    if (dialogType === 'parcel') {
      setCurrentObject({
        ...currentObject,
        Parcel: [
          ...currentObject.Parcel,
          {
            Parcel: newValue,
            RealEstate_idRealEstate: currentObject.idRealEstate,
          },
        ],
      });
    } else {
      setCurrentObject({
        ...currentObject,
        LandParcel: [
          ...currentObject.LandParcel,
          {
            LandParcel: newValue,
            RealEstate_idRealEstate: currentObject.idRealEstate,
          },
        ],
      });
    }
  };*/
  type UpdateParcelArgs =
    | { dialogType: 'parcel'; items: IRealEstateParcel[] }
    | { dialogType: 'land'; items: IRealEstateLandParcel[] };

  /**const updateItems = ({ items, dialogType }: UpdateParcelArgs) => {
    if (dialogType === 'parcel') {
      setCurrentObject({
        ...currentObject,
        Parcel: items,
      });
    } else {
      setCurrentObject({
        ...currentObject,
        LandParcel: items,
      });
    }
  };**/

  return (
    <>
      <Typography
        variant='h5'
        sx={{ mt: marginTop === undefined ? 2 : marginTop, mb: 2 }}
      >
        Grundbuchinformationen
      </Typography>
      <Grid container spacing={2}>
        <Grid item sm={8}></Grid>
        <Grid item sm={4}></Grid>

        <Grid item sm={6}>
          <Box
            sx={{
              border: '1px solid rgba(0, 0, 0, 0.23)',
              borderRadius: '4px',
              px: 1.5,
            }}
          >
            <Box
              onClick={() => setExpanded(!expanded)}
              sx={{
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'pointer',
                '&:hover': { backgroundColor: '#f9f9f9' },
              }}
            >
              {/* Links: Pfeil + Text */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  size='small'
                  edge='start'
                  sx={{
                    p: 0.5,
                    mr: 1,
                    color: 'text.secondary',
                  }}
                >
                  {expanded ? (
                    <ArrowUpward fontSize='small' />
                  ) : (
                    <ArrowDownward fontSize='small' />
                  )}
                </IconButton>
                <Typography
                  variant='body1'
                  color='text.secondary'
                  sx={{ lineHeight: 1 }}
                >
                  Flurstück(e)
                </Typography>
              </Box>

              {/* Rechts: Button */}
              {expanded && (
                <Button
                  sx={{ color: 'text.primary' }}
                  onClick={e => {
                    e.stopPropagation();
                    setDialogType('landparcel');
                    setIsOpenDialog(true);
                  }}
                >
                  + Flurstück
                </Button>
              )}
            </Box>
          </Box>
        </Grid>

        <Grid item sm={6}>
          <Box
            sx={{
              border: '1px solid rgba(0, 0, 0, 0.23)',
              borderRadius: '4px',
              px: 1.5,
            }}
          >
            <Box
              onClick={() => setExpanded2(!expanded2)}
              sx={{
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'pointer',
                '&:hover': { backgroundColor: '#f9f9f9' },
              }}
            >
              {/* Links: Pfeil + Text */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  size='small'
                  edge='start'
                  sx={{
                    p: 0.5,
                    mr: 1,
                    color: 'text.secondary',
                  }}
                >
                  {expanded2 ? (
                    <ArrowUpward fontSize='small' />
                  ) : (
                    <ArrowDownward fontSize='small' />
                  )}
                </IconButton>
                <Typography
                  variant='body1'
                  color='text.secondary'
                  sx={{ lineHeight: 1 }}
                >
                  Flur(e)
                </Typography>
              </Box>

              {/* Rechts: Button */}
              {expanded2 && (
                <Button
                  sx={{ color: 'text.primary' }}
                  onClick={e => {
                    e.stopPropagation();
                    setDialogType('parcel');
                    setIsOpenDialog(true);
                  }}
                >
                  + Flur
                </Button>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
